import React from "react";

import { PortalActions } from "./actions";
import { initialPortalState, PortalState } from "./state";

export type PortalContextValue = {
  state: PortalState;
  dispatch: React.ActionDispatch<[PortalActions]>;
};

export const PortalContext = React.createContext<PortalContextValue>({
  state: initialPortalState,
  dispatch: () => {
    console.error(
      "PortalContext: A vaild dispatch must be supplied in implementation"
    );
  },
});
